
import { createContext, useState } from "react";

export const TypeContext = createContext({
    productType: "instrument",
    updateProductType: (productType: any) => {},
    permissions: {},
    updatePermissions: (permission: any) => {}
});

export default function TypeContextProvider({children}: any) {
  const [productType, setProductType] = useState<any>('instrument');
  const [permissions, setPermissions] = useState<any>({});
  const updateProductType = (productType: any) => {
    setProductType(productType);
  }
  const updatePermissions = (permissions: any) => {
    setPermissions(permissions);
  }
  return (
    <TypeContext.Provider value={{productType, updateProductType, permissions, updatePermissions}}>
        {children}
    </TypeContext.Provider>
  )
}